<div class="body-content-area tabcontent" id="link1">
  <div class="row">
      <div class="col-lg-9">
          <div class="row">
              <div class="col-lg-1 low-padding text-center">
                  <!-- <img *ngIf="this.SelectedMenu.Image!=null" src={{this.SelectedMenu.Image}} class="body-icon" alt="Icon"/> -->
              </div>
              <div class="col-lg-10 clear-padding">
                  <span class="page-title">Approve/Reject Tour Expense Reimbursement Application</span>
                  <small class="page-description"></small>
              </div>
          </div>
      </div>
  </div>
  
  <div *ngIf="!(this.CanViewState)">
    <fieldset class="body-form-control">
      <legend class="legend--">Tour Expense Details</legend>

      <div *ngIf="NoRecordMsg" style="color: #dc3545; text-align: center;font-size: 15px; font-weight: bold;">No Record Found.</div>

      <table id="tblApplication" *ngIf="(this.ReimbursementApplications.length > 0)" class="table table-striped table-bordered text-center table-new row-border hover">
        <thead class="thead-blue text-center">
          <tr style=" width: 100%;">
            <th style=" width: 8%;">Sl No.</th>
            <th style=" width: 8%;">Code</th>
            <th style=" width: 18%;" class="text-left">Name</th>
            <th style=" width: 15%;" class="text-left">Expense Name</th>
            <th style=" width: 9%;">From Date</th>
            <th style=" width: 9%;">To Date</th>
            <th style=" width: 15%;" class="text-left">Tour Place</th>
            <th style=" width: 12%;" class="text-right">Expected Amount</th>
            <th style=" width: 6%;">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let appl of ReimbursementApplications, let i = index">
            <td scope="row">{{i+1}}</td>
            <td>{{appl.EmployeeCode}}</td>
            <td class="text-left">{{appl.EmployeeName}}</td>
            <td class="text-left">{{appl.ExpenseName}}</td>
            <td class="text-center">{{appl.FromDate| date : "dd-MMM-yyyy"}}</td>
            <td class="text-center">{{appl.ToDate| date : "dd-MMM-yyyy"}}</td>
            <td class="text-left">{{appl.TourPlace}}</td>
            <td class="text-right">{{appl.ExpectedExpenseAmount}}</td>
            <td>
              <button *ngIf="this.SelectedMenu.CanView" type="button" (click)="viewTourReimbursementDetails(appl.RefIdTR,template)" class="table-view-button" type="button" ><i class="fas fa-eye"></i></button>
            </td>
          </tr>
        </tbody>
        <tfoot class="thead-blue text-center">
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </tfoot>
      </table>
    </fieldset>

    <div style=" box-align: center; width: 1500px;" >
      <ng-template #template>
        <div class="modal-header" style="background: #2a9bd7; max-width: 1500px;"> 
          <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()" style="color:#fff;">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div  style="text-align: center; max-width: 1500px;">
          <div *ngIf="ApprovedMsg" style="color: #dc3545; text-align: center;font-size: 15px; font-weight: bold;">Application Farward to HR Successfully</div>
          <div *ngIf="RejectedMsg" style="color: #dc3545; text-align: center;font-size: 15px; font-weight: bold;">Application Rejected Successfully</div>
          <div style=" width: 100%;" *ngIf="ShowPopup">
            <fieldset *ngIf="GridShow" class="body-form-control" style=" text-align:left;"> 
              <legend class="legend--">Tour Expense Approval</legend>
              <form #TourReibursementForm="ngForm">
                <div class="row"> 
                  <div class="col-lg-4">
                    <div class="col-body-border-right">
                      <div class="form-group row">
                        <label  class="col-sm-4 col-form-label clear-padding-right">Employee Code</label>
                        <div class="col-sm-7 clear-left-padding">
                          :&nbsp;&nbsp;{{this.ModelListApplication.EmployeeCode}}
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-sm-4 col-form-label clear-padding-right">Expense Name</label>
                        <div class="col-sm-7 clear-left-padding">
                          :&nbsp;&nbsp;{{this.ModelListApplication.ExpenseName}}
                        </div>
                      </div>  
                      <div class="form-group row">
                        <label  class="col-sm-4 col-form-label clear-padding-right">From Date</label>
                        <div class="col-sm-7 clear-left-padding">
                          :&nbsp;&nbsp;{{this.ModelListApplication.FromDate | date:'dd-MMM-yyyy'}}
                        </div>
                      </div>
                      <div class="form-group row">
                        <label  class="col-sm-4 col-form-label clear-padding-right">No Of Trip</label>
                        <div class="col-sm-7 clear-left-padding">
                          :&nbsp;&nbsp;{{this.ModelListApplication.NOofTrip}} 
                        </div>
                      </div>      
                    </div>  
                  </div>
        
                  <div class="col-lg-4">
                    <div class="col-body-border-right">
                      <div class="form-group row">
                        <label  class="col-sm-4 col-form-label clear-padding-right">Name</label>
                        <div class="col-sm-7 clear-left-padding">
                          :&nbsp;&nbsp;{{this.ModelListApplication.EmployeeName}}
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-sm-4 col-form-label clear-padding-right">Tour Place</label>
                        <div class="col-sm-7 clear-left-padding">
                          :&nbsp;&nbsp;{{this.ModelListApplication.TourPlace}}
                        </div>
                      </div> 
                      <div class="form-group row">
                        <label  class="col-sm-4 col-form-label clear-padding-right">To Date</label>
                        <div class="col-sm-7 clear-left-padding">
                          :&nbsp;&nbsp;{{this.ModelListApplication.ToDate | date:'dd-MMM-yyyy'}}
                        </div>
                      </div>
                      <div class="form-group row">
                        <label  class="col-sm-4 col-form-label clear-padding-right">No of Days </label>
                        <div class="col-sm-7 clear-left-padding">
                          :&nbsp;&nbsp;{{this.ModelListApplication.NoOfDays}}
                        </div> 
                      </div> 
                    </div>
                  </div>
        
                  <div class="col-lg-4">
                    <div class="form-group row">
                      <label  class="col-sm-4 col-form-label clear-padding-right">Available Amount</label>
                      <div class="col-sm-7 clear-left-padding">
                        :&nbsp;&nbsp;{{this.ModelListApplication.NetAvailableAmount}} 
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-4 col-form-label clear-padding-right">HR</label>
                      <div class="col-sm-7 clear-left-padding">
                        :&nbsp;&nbsp;{{this.ModelListApplication.HRNames}} 
                      </div>
                    </div>
                    <div class="form-group row">
                      <label  class="col-sm-4 col-form-label clear-padding-right">Advance Date</label>
                      <div class="col-sm-7 clear-left-padding">
                        :&nbsp;&nbsp;{{this.ModelListApplication.AdvancePaidDate | date:'dd-MMM-yyyy'}}
                      </div>
                    </div>
                    <div class="form-group row">
                      <label  class="col-sm-4 col-form-label clear-padding-right">No of Nights </label>
                      <div class="col-sm-7 clear-left-padding">
                        :&nbsp;&nbsp;{{this.ModelListApplication.NoOfNights}}
                      </div> 
                    </div>
                  </div> 
                </div> 
        
                <div lass="row" >
                  <table id="tblExpense" class="table table-striped table-bordered text-left table-new row-border hover" style="width: 100%;">
                    <thead class="thead-blue text-center"s tyle="width: 100%;">
                      <tr>
                        <th style=" text-align: center;">Expense Head</th>
                        <th style=" text-align: left;">Budget Amount</th>
                        <th style=" text-align: left;">Expected Expense Amount</th> 
                        <th style=" text-align: left;">Approved Expense Amount</th>  
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let TEH of TourExpenseHeads, let i = index">
                        <td>
                          {{TEH.ExpenseHeadName}}
                          <input type="text" hidden="hidden" [(ngModel)]="TEH.RefIdTRD" name="RefIdTRD_{{i}}" #RefIdTRD="ngModel">
                        </td>
                        <td style=" text-align: right;">
                          {{TEH.BudgetAmount}}
                        </td>
                        <td style=" text-align: right;">
                          {{TEH.ExpenseAmount}}
                        </td>
                        <td>
                          <input type="text" [(ngModel)]="TEH.ApprovedExpenseAmount" name="ApprovedExpenseAmount_{{i}}" #ApprovedExpenseAmount="ngModel" pattern="[0-9]+" (ngModelChange)="ApprovedExpenseAmountChanged()" class="form-control form-control-custom form-control-custom-new" required>
                          <div *ngIf="ApprovedExpenseAmount.invalid && (ApprovedExpenseAmount.dirty || ApprovedExpenseAmount.touched)" class="alert alert-danger">
                            <div *ngIf="ApprovedExpenseAmount.errors?.pattern">Amount should be valid.</div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot class="thead-blue text-center">
                      <tr>
                        <th style=" text-align: right;"></th>
                        <th style=" text-align: right;">Total Expense Amount</th>
                        <th style=" text-align: right;">: &nbsp;&nbsp;{{this.ModelListApplication.ExpectedExpenseAmount}}</th>
                        <th style=" text-align: left;">: &nbsp;&nbsp;{{this.ModelListApplication.ApprovedExpenseAmount}}</th>  
                      </tr>
                    </tfoot>
                  </table>
                </div>
        
                <div class="row">
                  <div class="col-lg-4">
                    <div class="col-body-border-right">
                      <div class="form-group row">
                        <label class="col-sm-4 col-form-label clear-padding-right">Advance Amount</label>
                        <div class="col-sm-7 clear-left-padding">
                          <input style=" width: 80%;" disabled="true" type="text" [(ngModel)]="this.ModelListApplication.AdvanceAmount" id ="AdvanceAmount" name="AdvanceAmount" pattern="[0-9]+" #AdvanceAmount="ngModel" required class="form-control form-control-custom form-control-custom-new">
                          <!-- :&nbsp;&nbsp;{{this.ModelListApplication.AdvanceAmount}} -->
                        </div>
                        <div *ngIf="AdvanceAmount.invalid && (AdvanceAmount.dirty || AdvanceAmount.touched)" class="alert alert-danger">
                          <div *ngIf="AdvanceAmount.errors.required">Advance Amount is required.</div>
                          <div *ngIf="AdvanceAmount.errors?.pattern">Advance Amount should be valid.</div>
                        </div>
                      </div> 
                    </div> 
                  </div>
          
                  <div class="col-lg-4">
                    <div class="col-body-border-right">
                      <div class="form-group row">
                        <label  class="col-sm-4 col-form-label clear-padding-right">Remarks</label>
                        <div class="col-sm-7 clear-left-padding">
                          <input type="text" [(ngModel)]="ModelListApplication.RHRemarks" maxlength="500" id ="RHRemarks" name="RHRemarks" #RHRemarks="ngModel" required class="form-control form-control-custom form-control-custom-new" >
                        </div>
                      </div>
                    </div> 
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group row">
                      <div *ngIf="!(this.CanApproveState)" class="col-sm-6 col-form-label text-center">
                        <button type="submit" (click)="ApprovedTourReimbursement(template)" class="btn btn-primary save-button" [disabled]="!(TourReibursementForm.valid && this.DisableSave==true && (this.ModelListApplication.NetAvailableAmount + this.ModelListApplication.ExpectedExpenseAmount) - this.ModelListApplication.ApprovedExpenseAmount >= 0)">Approved</button>  
                      </div>
                      <div class="form-group row">
                        <div class="alert alert-danger" *ngIf="((this.ModelListApplication.NetAvailableAmount + this.ModelListApplication.ExpectedExpenseAmount) -(this.ModelListApplication.ApprovedExpenseAmount ) ) < 0 ">You Have Insufficant Amount To Applied.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>

          <button type="button" aria-label="Close" (click)="modalRef.hide()" style="background: #2a9bd7; outline: 0px none; border: 0px none; color: #fff; padding: 5px 10px; border-radius: 3px;">
            <span>Close</span>
          </button>             
        </div>
      </ng-template>
    </div>

  </div>
</div>